import { useLayoutEffect } from 'react';
import { CatalogFilterBlueprint } from '@backstage/plugin-catalog-react/alpha';

// Override of the stock catalog-filter:catalog/list.
// - alwaysKeepFilters disables the "owned → all" auto-switch, so a user who owns
//   no entities sees an empty list instead of every public entity.
// - EagerOwnedFilter applies owned([]) synchronously on mount so the FIRST catalog
//   query is already owner-scoped. Without it, EntityListProvider issues its first
//   getEntities() with no user filter (UserListPicker waits for the async
//   ownershipEntityRefs), so the public Component:backstage flashes into the list
//   for ~50-200ms before the owned filter removes it. owned([]) -> server filter
//   {relations.ownedBy: []} -> matches nothing, so the first paint is a skeleton,
//   not the unfiltered list. UserListPicker re-applies owned(<real refs>) once
//   identity resolves.
export const ownedListFilter = CatalogFilterBlueprint.make({
  name: 'list',
  params: {
    loader: async () => {
      const { UserListPicker, EntityUserFilter, useEntityList } = await import(
        '@backstage/plugin-catalog-react'
      );

      const EagerOwnedFilter = () => {
        const { updateFilters } = useEntityList();
        useLayoutEffect(() => {
          updateFilters({ user: EntityUserFilter.owned([]) });
        }, [updateFilters]);
        return null;
      };

      return (
        <>
          <EagerOwnedFilter />
          <UserListPicker initialFilter="owned" alwaysKeepFilters />
        </>
      );
    },
  },
});
